// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate` to regenerate.

import type { LucideIcon } from 'lucide-react';
import {
  Activity,
  AlertCircle,
  Archive,
  ArrowRight,
  ArrowRightLeft,
  BadgeCheck,
  BarChart3,
  BellRing,
  BookOpen,
  Bot,
  Box,
  Boxes,
  Brain,
  Building,
  Building2,
  Cable,
  CalendarClock,
  Camera,
  CheckCircle2,
  ChevronDown,
  Clock,
  Cloud,
  Code,
  Contact,
  Cpu,
  CreditCard,
  Crown,
  Database,
  DatabaseBackup,
  Download,
  Eye,
  FileCheck,
  FileCheck2,
  FileText,
  Fingerprint,
  FlaskConical,
  Gauge,
  Gem,
  GitBranch,
  GitCommit,
  GitCompare,
  GitCompareArrows,
  GitMerge,
  GitPullRequestArrow,
  Globe,
  Handshake,
  HardDrive,
  HeartPulse,
  HelpCircle,
  History,
  Home,
  Inbox,
  Key,
  KeyRound,
  Landmark,
  Layers,
  LayoutDashboard,
  LifeBuoy,
  Lightbulb,
  Link2,
  ListOrdered,
  Lock,
  Mail,
  Menu,
  Merge,
  MoonStar,
  MousePointerClick,
  Network,
  Newspaper,
  Package,
  PackageCheck,
  Pause,
  PenLine,
  Pencil,
  Play,
  Plug,
  Plus,
  PlusCircle,
  Radar,
  RefreshCcw,
  Repeat2,
  Rocket,
  RotateCcw,
  Route,
  Scale,
  ScanSearch,
  ScrollText,
  Search,
  Send,
  Server,
  Settings,
  Settings2,
  Shield,
  ShieldAlert,
  ShieldCheck,
  Signal,
  SlidersHorizontal,
  Sparkles,
  Table,
  Tag,
  Terminal,
  ToggleRight,
  TrendingUp,
  User,
  UserCog,
  Users,
  Webhook,
  Wifi,
  Workflow,
  Wrench,
  X,
  Zap,
} from 'lucide-react';

/** Icon name → lucide component, derived from every referenced name in the tree. */
export const ICON_MAP: Record<string, LucideIcon> = {
  Activity,
  AlertCircle,
  Archive,
  ArrowRight,
  ArrowRightLeft,
  BadgeCheck,
  BarChart3,
  BellRing,
  BookOpen,
  Bot,
  Box,
  Boxes,
  Brain,
  Building,
  Building2,
  Cable,
  CalendarClock,
  Camera,
  CheckCircle2,
  ChevronDown,
  Clock,
  Cloud,
  Code,
  Contact,
  Cpu,
  CreditCard,
  Crown,
  Database,
  DatabaseBackup,
  Download,
  Eye,
  FileCheck,
  FileCheck2,
  FileText,
  Fingerprint,
  FlaskConical,
  Gauge,
  Gem,
  GitBranch,
  GitCommit,
  GitCompare,
  GitCompareArrows,
  GitMerge,
  GitPullRequestArrow,
  Globe,
  Handshake,
  HardDrive,
  HeartPulse,
  HelpCircle,
  History,
  Home,
  Inbox,
  Key,
  KeyRound,
  Landmark,
  Layers,
  LayoutDashboard,
  LifeBuoy,
  Lightbulb,
  Link2,
  ListOrdered,
  Lock,
  Mail,
  Menu,
  Merge,
  MoonStar,
  MousePointerClick,
  Network,
  Newspaper,
  Package,
  PackageCheck,
  Pause,
  PenLine,
  Pencil,
  Play,
  Plug,
  Plus,
  PlusCircle,
  Radar,
  RefreshCcw,
  Repeat2,
  Rocket,
  RotateCcw,
  Route,
  Scale,
  ScanSearch,
  ScrollText,
  Search,
  Send,
  Server,
  Settings,
  Settings2,
  Shield,
  ShieldAlert,
  ShieldCheck,
  Signal,
  SlidersHorizontal,
  Sparkles,
  Table,
  Tag,
  Terminal,
  ToggleRight,
  TrendingUp,
  User,
  UserCog,
  Users,
  Webhook,
  Wifi,
  Workflow,
  Wrench,
  X,
  Zap,
};
